<!--
  @Description 问题汇总主界面
  @Date 2021-12-22
  @Author liushuo
  1.导入时，无需做判重操作
-->
<template>
  <div class="container">
    <homeHeader ref="HomeHeader" :isShowProjectSelect="true" @changeSelect="changeSelect" key="summary"></homeHeader>

    <div class="main">
      <!-- 表格 -->
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :parentData="this"
            ref="toolBarBtn"
            :moreButtonList="moreButtonList"
            :buttonVisible="buttonVisible"
          ></toolBarBtn>
        </div>

        <!-- 查找面板 -->
        <div class="search-dv" v-if="searchFormVisible">
          <SearchForm ref="SearchForm"></SearchForm>
        </div>

        <!-- 统计面板 -->
        <StatisticsPanel v-if="statisticsVisible" :tableData="statisticsData" :parentObj="this" />

        <!-- 表格 -->
        <div class="table-dv">
          <vxe-grid
            ref="xTable"
            resizable
            :data="tableData"
            size="mini"
            :mouse-config="{ area: true }"
            highlight-hover-row
            highlight-current-row
            :height="tableHeight"
            :columns="gridColumns"
            :cell-style="tableCellStyle"
            @cell-dblclick="handleDbClick"
            :row-config="{ height: 60 }"
            :showOverflow="true"
            :tooltip-config="{
              showAll: true,
              theme: 'dark'
            }"
            :keyboard-config="{
              isArrow: true,
              isEnter: true,
              isTab: true,
              isClip: true,
              enterToTab: true,
              isEdit: true
            }"
            @menu-click="contextMenuClickEvent"
            :menu-config="{ body: { options: bodyMenus }, visibleMethod }"
            @cell-menu="cellContextMenuEvent"
            :scroll-y="{
              mode: 'wheel'
            }"
            :seq-config="{
              startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
            }"
            :pager-config="tablePage"
            @page-change="handlePageChange"
            :clip-config="{
              copyMethod: copyMethod
            }"
            show-footer
            :footer-method="footerMethod"
            @filter-change="filterChange"
          >
          </vxe-grid>
        </div>
      </div>
    </div>

    <!-- 说明编辑 -->
    <InstructionEdit ref="InstructionEdit" :id="curSelectID" :parentObj="this"></InstructionEdit>

    <!-- 新增问题 -->
    <AddNewProblemModal ref="AddNewProblemModal" :parentObj="this"></AddNewProblemModal>

    <!-- 批量说明新增 -->
    <MoreInstructionEdit ref="MoreInstructionEdit" :parentObj="this"></MoreInstructionEdit>

    <!-- 下发流程弹窗填写 -->
    <issueFlowEdit ref="issueFlowEdit" @clearCheckBox="clearCheckBox"></issueFlowEdit>

    <!-- 领导意见 -->
    <OpinionEdit ref="OpinionEdit"></OpinionEdit>

    <!-- 导入 -->
    <Import ref="Import" @sureImportBack="sureImportBack"></Import>

    <!-- 员工档案 -->
    <EmployeeSelect
      ref="EmployeeSelect"
      :isMultiple="false"
      :sqlTitle="personSqlTitle"
      @sureBackPerson="sureBackPerson"
      :isRequired="true"
    />

    <!-- 多选人员 -->
    <EmployeeSelect
      ref="EmployeeMoreSelect"
      :isMultiple="true"
      :maxPickCount="2"
      :sqlTitle="personSqlTitle"
      @sureBackPerson="sureBackPersonMore"
      :isRequired="true"
    />

    <!-- 日期选择框 -->
    <DateInput ref="DateInput" @sureHandler="sureBackDate"></DateInput>

    <!-- 附件 -->
    <AttachmentDrawer
      ref="AttachmentDrawer"
      :attachmentDisplay.sync="attachmentDisplay"
      :parentObj="this"
      :edit="true"
      :keyValue="curSelectID"
    ></AttachmentDrawer>

    <!-- 工作量评估弹窗 -->
    <WorkTimeSelect ref="WorkTimeSelect"></WorkTimeSelect>
    <WorkTimeSelectForDesign ref="WorkTimeSelectForDesignRef" @commit="signDesign"></WorkTimeSelectForDesign>

    <!-- 天数选择框 -->
    <DaySelect ref="DaySelect" @sureBackDay="sureBackDay"></DaySelect>

    <!-- 批量输入 -->
    <BatchInput ref="BatchInput" @sureHandler="sureBackBatch" />

    <!-- 文件上传 -->
    <AttachmentUpload ref="AttachmentUpload" />

    <!-- 设计变更 -->
    <SetDesignHistoryModel ref="SetDesignHistoryModel" />

    <!-- 详细设计窗体 -->
    <DetailDesignEditModal ref="DetailDesignEditModalRef" />

    <!-- 查询详设 -->
    <DetailDesignSearch ref="DetailDesignSearchRef" />

    <!-- 设计变更历史抽屉 -->
    <QuestionUpdateHistory ref="QuestionUpdateHistory" />

    <!-- 只读问题汇总表格 -->
    <ReadonlySummaryModal ref="ReadonlySummaryModalRef" :parentObj="this" />

    <!-- 选择文件夹 -->
    <input type="file" ref="uploadExcel" v-show="false" id="open" multiple="multiple" @change="uploadFile" />
  </div>
</template>

<script>
import InstructionEdit from './instructionEdit'
import AddNewProblemModal from './addNewProblemModal'
import MoreInstructionEdit from './moreInstructionEdit'
import issueFlowEdit from './issueFlowEdit'
import OpinionEdit from './opinionEdit'
import Import from './import'
import WorkTimeSelect from './workTimeSelect'
import WorkTimeSelectForDesign from './workTimeSelectForDesign.vue'
import DaySelect from './daySelect'
import AttachmentUpload from '../../components/Modal/Attachment/AttachmentUpload'
// 设计变更内容
import SetDesignHistoryModel from './YKCaseDesign/setDesignHistoryModel'
import QuestionUpdateHistory from './YKCaseDesign/QuestionUpdateHistory'
import DetailDesignEditModal from './DetailDesign/EditModal.vue'
import DetailDesignSearch from './DetailDesign/DetailDesignSearch.vue'
import StatisticsPanel from './StatisticsPanel.vue'
import ReadonlySummaryModal from './readonlySummaryModal.vue'

export default {
  components: {
    InstructionEdit,
    MoreInstructionEdit,
    issueFlowEdit,
    OpinionEdit,
    Import,
    WorkTimeSelect,
    DaySelect,
    AttachmentUpload,
    AddNewProblemModal,
    SetDesignHistoryModel,
    QuestionUpdateHistory,
    DetailDesignEditModal,
    DetailDesignSearch,
    WorkTimeSelectForDesign,
    StatisticsPanel,
    ReadonlySummaryModal
  },
  data() {
    return {
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        // 默认每页条数
        pageSize: 200,
        align: 'right',
        // 每页条数
        pageSizes: [50, 100, 200, 500, 1000, 50000],
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      tableData: [],
      // 统计面板是否展开
      statisticsVisible: false,
      // 独立的统计面板数据
      statisticsData: [],
      // 统计面板高度（用于表格高度计算）
      statisticsPanelHeight: 300,
      searchFormVisible: false,
      // 列
      gridColumns: [],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组扩展按钮 { icon: xxx, name: xxx, event: xxx, visible: xxx }
      moreButtonList: [],
      // 是否显示附件弹窗
      attachmentDisplay: false,
      // 当前选中行的ID
      curSelectID: -1,
      // 当前选中行的ID列表
      curSelectAttchmentIDList: [],
      // 当前选中列名（用于判断要打开哪种类型的选择框，以及给哪一列赋值）
      curSelectCol: '',
      // 人员选择框过滤条件，格式如 'post:前端研发'
      personSqlTitle: '',
      // 是否全量查询问题 [全量 | 过滤本人]（用于缓存当前处于何种过滤状态，在操作结束后应按原先的过滤状态进行显示）
      isSearchAll: true,
      // 页面是否被锁定(除超级权限外，其他均不可操作)
      isLock: false,
      // 产品类型下拉框值
      optionsValue: '',
      // 批量输入框的类型 [文档编号 | 模块 | 页面]
      inputType: '',
      Authority: this.AuthorityFilter(this.$route.path),
      // 特殊权限
      specialAuthority: {},
      // 拉选区域
      areas: [],
      // 下拉框绑定值
      combobox: {
        // 产品类型选择框（铁塔、电杆等）
        ProductionType: []
      },
      // 右键菜单
      bodyMenus: [
        [
          {
            code: 'errorLevel',
            name: '一般'
          },
          {
            code: 'errorLevel',
            name: '严重'
          },
          {
            code: 'errorLevel',
            name: '清空',
            value: ''
          },
          {
            code: 'selectCheckbox',
            name: '选中'
          },
          {
            code: 'isPriority',
            name: '是'
          },
          {
            code: 'isPriority',
            name: '否'
          },
          {
            code: 'leaderViews',
            name: '新增领导意见'
          },
          {
            code: 'caseStatus',
            name: '不处理',
            // 后缀图标
            // suffixIcon: 'el-icon-s-tools'
            prefixIcon: 'el-icon-circle-close'
          },
          {
            code: 'caseStatus',
            name: '恢复处理',
            // 前缀图标
            prefixIcon: 'el-icon-refresh-right'
          },
          {
            code: 'sign',
            name: '签名'
          },
          {
            code: 'unSign',
            name: '撤销签名'
          },
          {
            code: 'comment',
            name: '新增说明'
          },
          {
            code: 'type',
            name: '完善'
          },
          {
            code: 'type',
            name: '新增'
          },
          {
            code: 'type',
            name: '错误'
          },
          {
            code: 'type',
            name: '性能'
          },
          {
            code: 'workTime',
            name: '互评工作量'
          },
          {
            code: 'daySelect',
            name: '选择天数'
          },
          {
            code: 'docNumber',
            name: '修改文档编号'
          },
          {
            code: 'vuePath',
            name: '修改页面名称'
          },
          {
            code: 'groupName',
            name: '修改模块'
          },
          {
            code: 'setDesign',
            name: '新增设计变更'
          },
          {
            code: 'setDetailDesign',
            name: '新增详细设计'
          },
          {
            code: 'viewDetailDesignByMenu',
            name: '查看详细设计(菜单)'
          },
          {
            code: 'viewDetailDesignByQuestion',
            name: '查看详细设计(问题)'
          },
          {
            code: 'searchDetailDesign',
            name: '查看历史详细设计'
          },
          {
            code: 'searchDesign',
            name: '查看历史变更记录'
          }
        ],
        [
          {
            code: 'caseStatusSet',
            name: '解决中'
          },
          {
            code: 'caseStatusSet',
            name: '技术测试通过'
          },
          {
            code: 'caseStatusSet',
            name: '业务测试通过'
          },
          {
            code: 'caseStatusSet',
            name: '已解决'
          },
          {
            code: 'caseStatusSet',
            name: '超期未解决'
          },
          {
            code: 'caseStatusSet',
            name: '超期已解决'
          }
        ]
      ],
      buttonVisible: {
        add: false, // 新增按钮是否显示
        update: false, // 编辑按钮是否显示
        delete: false, // 删除按钮是否显示
        save: true, // 保存按钮是否显示
        lock: true, // 锁定按钮是否显示
        unlock: true, // 解锁按钮是否显示
        sort: true, // 排序按钮是否显示
        search: true, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 人员岗位类型常量（用于签名、修改解决人等，与后端预设值保持一致）
      PERSONTYPE: {
        frontEngineer: '前端研发',
        backEngineer: '后端研发',
        techTester: '技术测试',
        businessTester: '业务测试',
        createtor: '提出人',
        research: '调研人',
        // 用于互评工作量，前后端需颠倒
        frontWorkTime: '后端评价人',
        backWorkTime: '前端评价人',
        // 用于改评价人，无需颠倒
        frontAssessor: '前端评价人',
        backAssessor: '后端评价人',
        techTestDay: '技术测试',
        businessTestDay: '业务测试',
        confirmDay: '提出人',
        frontDesigners: '前端设计人',
        backDesigners: '后端设计人'
      },
      // 用于人员选择框过滤用的字典
      perSqlTitleMap: {
        createtor: '项目经理',
        research: '',
        frontEngineer: '前端研发',
        backEngineer: '后端研发',
        techTester: '技术测试',
        businessTester: '业务测试',
        // 前端和后端评价人，对应前端和后端研发人员
        frontAssessor: '前端研发',
        backAssessor: '后端研发',
        frontDesigners: '前端研发',
        backDesigners: '后端研发'
      },
      // 单元格背景颜色字典
      cellBgColorMap: {
        yellow: '#FBFE56',
        orange: '#FFC000',
        purple: '#B791C6',
        red: '#FF8B8B',
        green: '#61BFAD',
        pink: '#F1C3B8'
      },
      // 单元格字体颜色（根据背景颜色匹配，key为背景颜色，value为文本颜色）
      cellTextColorMap: {
        yellow: '#101010',
        orange: '#101010',
        purple: '#000000',
        red: '#F9F8E6',
        green: '#FFFFFF',
        pink: '#101010'
      }
    }
  },
  created() {
    if (this.$store?.state?.systemSetting && this.$store?.state?.systemSetting.defaultSearch === 'my') {
      this.isSearchAll = false
    }
    this.InitColumns()
    this.getSpecial()
    this.bindCombobox()
  },
  async activated() {
    // 获取当前是否被锁定
    await this.getIsLock()
    // 注意！要先执行完 getIsLocak 才能根据锁定状态来初始化工具栏的锁定/解锁按钮
    this.initButton()
  },
  methods: {
    // 设置详细设计
    setDetailDesign(row) {
      this.$refs.DetailDesignEditModalRef.showModal(row)
    },
    // 查看详细设计
    viewDetailDesign(row, numOptions = []) {
      this.$refs.DetailDesignSearchRef.openModal(row, numOptions)
    },
    // 复制内容方法
    copyMethod({ row, column, cellValue }) {
      switch (column.property) {
        case 'designHistory':
        case 'comment':
          return this.formatContentWrap(row, column, 'left', true, true)
        default:
          return cellValue
      }
    },
    // 查看设计变更
    async openDesignHistoryWindow(body) {
      const { data: res } = await this.$http.post('/Common/YKCaseDesign/history', body)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      // --------------判断是否为单行--------------
      let hasLeft = false
      let hasRight = false
      // 默认单行
      let dataIsSingleCol = true
      for (let item of res.data) {
        if (['后端', '数据库'].includes(item.type)) {
          hasRight = true
        } else {
          hasLeft = true
        }
        // 如果都有数据的话就为多行
        if (hasLeft && hasRight) {
          dataIsSingleCol = false
          break
        }
      }
      this.$refs.QuestionUpdateHistory.dataIsSingleCol = dataIsSingleCol
      // -----------------------------------------

      this.$refs.QuestionUpdateHistory.questionHistoryList = res.data
      this.$refs.QuestionUpdateHistory.showDrawer = true
    },
    // 设置本行设计变更
    setRowDesign(row) {
      this.$refs.SetDesignHistoryModel.row = row
      this.$refs.SetDesignHistoryModel.isShow = true
    },
    // 跳转下发流程
    handleJumpDistribute(row) {
      console.log(row)
    },
    // 设置列
    InitColumns() {
      // width
      // 35: 两个字两行
      // 50: 两个字
      // 55: 四个字两行
      // 65: 三个字
      // 75: 四个字
      this.gridColumns = [
        { type: 'seq', width: 60, fixed: 'left' },
        {
          fixed: 'left',
          type: 'checkbox',
          width: '50px'
        },
        // {
        //   title: '是否已下发',
        //   fixed: 'left',
        //   field: 'isIssued',
        //   width: '60px',
        //   filters: [
        //     {
        //       data: {
        //         vals: [],
        //         sVal: '',
        //         fMenu: '',
        //         f1Type: '',
        //         f1Val: '',
        //         fMode: 'and',
        //         f2Type: '',
        //         f2Val: ''
        //       }
        //     }
        //   ],
        //   filterRender: { name: 'FilterExtend' }
        // },
        // 问题编号宽度55可以容纳四位数序号，如：T1657
        {
          title: '问题编号',
          width: 55,
          fixed: 'left',
          field: 'num',
          filters: [{ data: { val1: '', val2: '' } }],
          filterRender: { name: 'FilterInputRange' }
          // filters: [
          //   {
          //     data: {
          //       vals: [],
          //       sVal: '',
          //       fMenu: '',
          //       f1Type: '',
          //       f1Val: '',
          //       fMode: 'and',
          //       f2Type: '',
          //       f2Val: '',
          //     },
          //   },
          // ],
          // filterRender: { name: 'FilterExtend' },
        },
        {
          title: '系统版本',
          width: 60,
          fixed: 'left',
          field: 'productionVersion',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '下发编号',
          field: 'isIssued',
          fixed: 'left',
          width: '80px',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' },
          slots: {
            default: ({ row, column }) => {
              // if (!row[column.property]) {
              //   return '/'
              // } else {
              return [
                <span>{row[column.property]}</span>
                // <el-link
                //   type='primary'
                //   onClick={() => {
                //     {
                //       this.handleJumpDistribute(row)
                //     }
                //   }}
                // >
                //   {row[column.property]}
                // </el-link>
              ]
              // }
            }
          }
        },
        // filter 分类：
        // 1.简单输入框 FilterInput
        // 2.简单单选框（是/否）filterMultiple: false
        // 3.复杂筛选（包含输入、选择）FilterExtend
        {
          title: '模块',
          width: 70,
          fixed: 'left',
          field: 'groupName',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '页面',
          width: 80,
          fixed: 'left',
          field: 'vuePath',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '问题内容',
          width: 180,
          fixed: 'left',
          field: 'content',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' }
        },
        {
          title: '紧急',
          width: 40,
          fixed: 'left',
          field: 'isPriority',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '登记单位',
          width: 90,
          field: 'companys',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' },
          slots: {
            default: ({ row, column }) => {
              if (!row[column.property]) {
                return '/'
              } else {
                return row[column.property]
              }
            }
          },
          exportMethod: ({ row, column }) => {
            if (!row[column.property]) {
              return '/'
            } else {
              return row[column.property]
            }
          }
        },
        {
          title: '文档编号',
          width: 50,
          field: 'docNumber',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '类型',
          width: 35,
          field: 'type',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '错误等级',
          width: 50,
          field: 'errorLevel',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '提出人',
          width: 60,
          field: 'createtor',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        // {
        //   title: '调研人', width: 60,  field: 'research',
        //   filters: [{ data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }], filterRender: { name: 'FilterExtend' }
        // },
        {
          title: '提出日期',
          width: 85,
          field: 'createDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '截止日期',
          width: 85,
          field: 'dueDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '前端设计人',
          width: 110,
          field: 'frontDesigners',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端设计确认时间',
          width: 120,
          field: 'frontDesignConfirmationTime',
          formatter: ['formatDate', 'yyyy-MM-dd'],
          // visible: false
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '前端详细设计',
          width: 100,
          field: 'frontDesignCol',
          slots: {
            default: ({ row }) => {
              return row.frontDetailDesignLastID > 0 ? '已设计' : '/'
            }
          }
        },
        {
          title: '后端设计人',
          width: 110,
          field: 'backDesigners',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端设计确认时间',
          width: 120,
          field: 'backDesignConfirmationTime',
          formatter: ['formatDate', 'yyyy-MM-dd'],
          // visible: false
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '后端详细设计',
          width: 100,
          field: 'backDesignCol',
          slots: {
            default: ({ row }) => {
              return row.backDetailDesignLastID > 0 ? '已设计' : '/'
            }
          }
        },
        {
          title: '前端研发',
          width: 70,
          field: 'frontEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端研发',
          width: 70,
          field: 'backEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端评价人',
          width: 70,
          field: 'frontAssessor',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端评价人',
          width: 70,
          field: 'backAssessor',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端工作量',
          width: 70,
          field: 'frontWorkTime',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端工作量',
          width: 70,
          field: 'backWorkTime',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '技术测试',
          width: 70,
          field: 'techTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '业务测试',
          width: 70,
          field: 'businessTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        // todo 详细设计列
        {
          title: '设计变更',
          width: 150,
          field: 'designHistory',
          slots: {
            default: ({ row, column }) => {
              const isLongContent = true
              return this.formatContentWrap(row, column, 'left', isLongContent)
            }
          },
          exportMethod: ({ row, column }) => {
            // 格式化导出内容
            const isLongContent = true
            const isExport = true
            return this.formatContentWrap(row, column, 'left', isLongContent, isExport)
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
          // filters: [{ data: null }], filterRender: { name: 'FilterInput' }
        },
        {
          title: '说明内容',
          width: 200,
          field: 'comment',
          slots: {
            default: ({ row, column }) => {
              const isMemo = true
              return this.formatContentWrap(row, column, 'left', isMemo)
            }
          },
          exportMethod: ({ row }) => {
            // 注意！不能用原列值导出，会有乱码
            // 只能用后端格式化后的说明列(exportComment)进行导出
            const exportComment = row['exportComment']
            return exportComment
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
          // filters: [{ data: null }], filterRender: { name: 'FilterInput' }
        },
        {
          title: '领导意见',
          width: 80,
          field: 'leaderViews',
          slots: {
            default: ({ row, column }) => {
              const isMemo = true
              return this.formatContentWrap(row, column, 'left', isMemo)
            }
          },
          exportMethod: ({ row }) => {
            // 注意！不能用原列值导出，会有乱码
            // 只能用后端格式化后的说明列(exportLeaderView)进行导出
            const exportLeaderView = row['exportLeaderView']
            return exportLeaderView
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '签名状态',
          width: 80,
          field: 'signStatus',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端解决日期',
          width: 85,
          field: 'frontResolvedDateStr',
          slots: {
            default: ({ row, column }) => {
              return this.formatContentWrap(row, column)
            }
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端最后解决日期',
          width: 85,
          field: 'frontResolvedDate',
          formatter: 'formatDate',
          // visible: false
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '后端解决日期',
          width: 85,
          field: 'backResolvedDateStr',
          slots: {
            default: ({ row, column }) => {
              return this.formatContentWrap(row, column)
            }
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端最后解决日期',
          width: 85,
          field: 'backResolvedDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
          //  visible: false
        },
        {
          title: '问题状态',
          width: 80,
          field: 'caseStatus',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '技术测试确认日期',
          width: 85,
          field: 'techTestDateStr',
          slots: {
            default: ({ row, column }) => {
              return this.formatContentWrap(row, column)
            }
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '技术测试最后确认日期',
          width: 85,
          field: 'techTestDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
          //  visible: false
        },
        {
          title: '天数',
          width: 80,
          field: 'techTestDay',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '业务测试确认日期',
          width: 85,
          field: 'businessTestDateStr',
          slots: {
            default: ({ row, column }) => {
              return this.formatContentWrap(row, column)
            }
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '业务测试最后确认日期',
          width: 85,
          field: 'businessTestDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
          //  visible: false
        },
        {
          title: '天数',
          width: 80,
          field: 'businessTestDay',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '提出人确认日期',
          width: 85,
          field: 'confirmDate',
          formatter: 'formatDate',
          // slots:
          // {
          //   default: ({ row, column }) => {
          //     return this.formatContentWrap(row, column)
          //   }
          // },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '提出人确认天数',
          width: 80,
          field: 'confirmDay',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '当前节点',
          width: 80,
          field: 'result',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '排序',
          width: 80,
          field: 'sort',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '附件',
          width: 160,
          field: 'fileURL',
          slots: {
            default: ({ row }) => {
              return [
                // 可上传条件：1.有超级权限  2.有附件上传权限
                <el-link
                  disabled={!this.specialAuthority.super && !this.specialAuthority.attachment}
                  onClick={() =>
                    // 打开文件
                    {
                      this.handleOpenFile(row, 'singleRow')
                    }
                  }
                  type='primary'
                  style='margin-right: 10px'
                >
                  <i class='el-icon-upload2' style='margin-right:5px'></i>
                  {'上传'}
                </el-link>,
                <el-link disabled={!row.fileURL} onClick={() => this.openAttachmentDisplay(row)} type='primary'>
                  <i class='el-icon-link' style='margin-right:5px'></i>
                  {'附件'}
                </el-link>
              ]
            }
          }
        }
      ]
    },
    // 获取特殊权限，格式如：specialAuthority:{ '权限名称':true }
    getSpecial() {
      // 汇总界面特殊权限 [super(超级权限) | worktime(工作量评估特殊权限) | leader(领导意见)] | confirmIssued(确认下发)
      this.Authority.special.forEach(v => {
        this.specialAuthority[v.name] = true
      })
    },
    // 获取下拉框值
    async bindCombobox() {
      const { data: res } = await this.$http.post('/Common/ProductVersionSet/list?sqlTitle=all')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      res.data.forEach(item => {
        const temp = {
          code: 'productionVersion',
          // 产品名称（系统版本）
          name: item.productionVersion,
          // 产品类型
          comment: item.productionType
        }

        this.bodyMenus[0].push(temp)
      })
    },
    // 当前页面是否被锁定，若被锁定则只有超级权限能操作
    async getIsLock() {
      const { data: res } = await this.$http.get('/Common/YKCase/islock')
      if (!res.isSuccess) {
        this.$message.error('获取锁定状态失败')
        return false
      }
      this.isLock = res.data
    },
    // 初始化按钮组
    initButton() {
      // 需要根据特殊权限控制部分按钮可见性
      this.buttonVisible = {
        save: !!this.specialAuthority.super, // 保存按钮是否显示
        // lock: !!this.specialAuthority.super, // 锁定按钮是否显示
        // unlock: !!this.specialAuthority.super, // 解锁按钮是否显示
        add: false, // 新增按钮是否显示
        update: false, // 编辑按钮是否显示
        delete: false, // 删除按钮是否显示
        sort: false, // 排序按钮是否显示
        search: true, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      }

      this.moreButtonList = [
        {
          // icon: 'el-icon-download',
          icon: 'el-icon-circle-plus-outline',
          name: '新增问题',
          event: 'addNewProblem',
          // 与导入的权限保持一致
          visible: !!this.specialAuthority.super,
          disabled: !this.Authority.edit || !this.specialAuthority.super
        },
        {
          // icon: 'el-icon-download',
          icon: 'iconfont fjyk-daoru-03-copy',
          name: '导入',
          event: 'import',
          visible: !!this.specialAuthority.super,
          disabled: !this.Authority.edit || !this.specialAuthority.super
        },
        {
          // icon: 'el-icon-upload2',
          icon: 'iconfont fjyk-daochu-03-copy',
          name: '导出',
          event: 'export',
          disabled: !this.Authority.edit
        },
        {
          name: '锁定',
          icon: 'el-icon-lock',
          visible: !!this.specialAuthority.super,
          // 禁用条件：1.无超级权限 或 2.当前状态处于锁定
          disabled: !this.specialAuthority.super || this.isLock,
          event: 'lock'
        },
        {
          name: '解锁',
          icon: 'el-icon-unlock',
          visible: !!this.specialAuthority.super,
          // 禁用条件：1.无超级权限 或 2.当前状态处于未锁定
          disabled: !this.specialAuthority.super || !this.isLock,
          event: 'unlock'
        },
        {
          name: '清空筛选',
          icon: 'el-icon-brush',
          disabled: false,
          event: 'clearFilter'
        },
        {
          name: '附件上传',
          icon: 'el-icon-folder-opened',
          // 可用条件：1.有超级权限  2.有附件上传权限
          visible: !!this.specialAuthority.super || !!this.specialAuthority.attachment,
          disabled: !this.specialAuthority.super && !this.specialAuthority.attachment,
          event: 'handleOpenFile'
          // event: 'attachmentUpload',
        },
        {
          name: '生成下发流程',
          icon: 'el-icon-tickets',
          visible: !!this.specialAuthority.confirmIssued,
          // 禁用条件：无下发权限
          disabled: !this.specialAuthority.confirmIssued,
          event: 'handleIssuedFlow'
        },
        {
          name: '数据统计',
          icon: 'el-icon-data-analysis',
          disabled: false,
          event: 'toggleStatistics'
        }
      ]

      // 快捷筛选出要解决的问题
      if (
        String(this.$store.state.userInfo.gangWei).includes('前端研发') ||
        String(this.$store.state.userInfo.gangWei).includes('后端研发')
      ) {
        this.moreButtonList.push({
          name: '筛选未解决问题',
          icon: 'el-icon-attract',
          disabled: false,
          event: 'searchUncomplete'
        })
      }
    },
    /**
     * 获取问题汇总数据
     * @param isResetPager 是否重置当前页码
     * @param isToUncomplete 是否滚动到[未完成]问题的位置
     */
    async getList(isResetPager = false, isToUncomplete = false) {
      let sqlTitle = this.searchSqlTitle
      if (isToUncomplete) {
        sqlTitle = 'toUncomplete'
        this.isSearchAll = true
      }
      if (isResetPager) {
        this.tablePage.currentPage = 1
      }
      // 获取主表数据(全量刷新)
      // 调用情况：1.头部组件在获取产品类型的值后调用  2.切换产品类型后调用  3.点击刷新按钮调用
      if (!this.Authority.see) {
        this.$message.warning('您没有查看权限!')
        return
      }
      const { data: res } = await this.$http.post('/Common/YKCase/list', {
        menuArgs: this.curProductType,
        // 用于过滤数据，目前先按照全量查询 [default: 过滤本人；不写default则全部查询]
        sqlTitle: sqlTitle,
        // 权限
        seeType: this.Authority.seeType,
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      // 01-26 重新请求数据时，不清空所有筛选条件
      // this.$refs.xTable.clearFilter()
      this.tableData = res.data.rows.map(row => {
        // 240619 刘福: 提出日期是带时分秒的, 去掉时分秒, 影响筛选
        return {
          ...row,
          createDate: this.ykDateFormat('yyyy-MM-dd', row.createDate)
        }
      })
      this.tablePage.total = res.data.totals

      // 若需跳转到[未完成]问题，则将当前页码改为后端返回的页码，并跳转
      if (isToUncomplete) {
        this.tablePage.currentPage = res.data.jumpPage
        // 查看全部时，需要将表格滚动条滑动到最后一条排序为1的数据
        this.setScrollToTarget(res)
      }

      this.refreshStatisticsData()
    },

    // 将表格滚动条滑动到最后一条排序为1的数据
    setScrollToTarget(res) {
      let tableDOM = document.getElementsByClassName('vxe-table--body-wrapper body--wrapper')[0]
      tableDOM.scrollTop = 0

      if (this.isSearchAll) {
        setTimeout(() => {
          tableDOM.scrollTop = this.getScrollTop(res)
        }, 500)
      } else {
        setTimeout(() => {
          tableDOM.scrollTop = 0
        }, 500)
      }
    },

    // 获取滚动条需要滚动的距离(滚动到排序为1的最后一条数据)
    getScrollTop(res) {
      // 单元格高度 80px
      const cellHeight = 80
      let count = 0
      for (let row of res.data.rows) {
        if (row.sort !== 1) {
          break
        }
        count++
      }
      return count * cellHeight
    },

    /**
     * 获取主表数据(局部刷新)
     * @description 进行行操作后，进行局部刷新，不改变数据排序
     */
    async getListPart() {
      if (!this.Authority.see) {
        this.$message.warning('您没有查看权限!')
        return
      }
      const { data: res } = await this.$http.post('/Common/YKCase/list', {
        menuArgs: this.curProductType,
        // 局部刷新时，不能过滤本人，提出人确认后会把问题状态改为已解决，因此返回的数据中不包含已通过的数据，因此匹配不上数据从而刷新不了
        sqlTitle: '',
        // 权限
        seeType: this.Authority.seeType,
        // 分页后的逻辑：需获取所有数据来进行匹配，不能使用分页数据（操作后可能导致排序变化，从而在当前页获取不到当前数据）
        pageIndex: 1,
        pageSize: 99999
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      // 分页后的逻辑：局部刷新当前分页内的表格数据
      const tableData = this.$refs.xTable.getTableData().fullData
      const tableIDList = tableData.map(row => {
        return row.id
      })
      this.updateByRows(tableIDList, res)
    },

    // 局部更新
    updateByRows(idList, res) {
      // 更新的行数据
      const updateRow = res.data.rows.filter(item => {
        return idList.includes(item.id)
      })

      for (let i = 0; i < updateRow.length; i++) {
        for (let j = 0; j < this.tableData.length; j++) {
          // 若id匹配，则进行当前行数据的赋值
          if (updateRow[i].id === this.tableData[j].id) {
            // 240619 刘福: 提出日期是带时分秒的, 去掉时分秒, 影响筛选
            let row = updateRow[i]
            row = { ...row, createDate: this.ykDateFormat('yyyy-MM-dd', row.createDate) }
            this.tableData.splice(j, 1, row)
            break
          }
        }
      }
      this.refreshStatisticsData()
    },
    /**
     * @description 格式化需要换行的列，如说明、签字日期
     * @param {Object} row 行数据
     * @param {Object} column 列数据
     * @param {String} align 文字排版位置，可选值 left | center | right
     * @param {Boolean} isMemo 是否为说明、领导意见、设计变更（若是，则需要分割句内字段；'!#!'用于分割句；'!&!'用于分割句内字段）输出VNode
     * @param {Boolean} isExport 是否为导出字段（若是，则需要分割句内字段；'!#!'用于分割句；'!&!'用于分割句内字段）输出字符串
     */
    formatContentWrap(row, column, align = 'center', isMemo = false, isExport = false) {
      if (row[column.property] == null || row[column.property] == '') {
        return ''
      }
      // 分割后的值
      const wrap = row[column.property].split('!#!')
      // 当前值需要分割句内字段，如说明
      if (isMemo) {
        // 说明
        if (column.property === 'comment') {
          if (isExport) {
            return wrap
              .map(item => {
                // word 固定格式为
                // [0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:id
                const word = item.split('!&!')

                // 使用div（块级元素）即可实现span分行
                // white-space 可以让 div 内超出宽度的文字换行，但表格自带的 tooltip 会丢失
                return `[${word[0] || '无'}] ${word[1] || '无'} ${word[2] || '无'}: ${word[3] || '无'}`
              })
              .join('\n')
          } else {
            return [
              wrap.map((item, index) => {
                // word 固定格式为
                // [0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:id
                const word = item.split('!&!')

                // 使用div（块级元素）即可实现span分行
                // white-space 可以让 div 内超出宽度的文字换行，但表格自带的 tooltip 会丢失
                return (
                  <div style={`text-align:${align};white-space:normal; `} key={index}>
                    <span style='color:#555'>{`[${word[0] || '无'}] `}</span>
                    <span>{`${word[1]} ` || '无'}</span>
                    <span style='font-weight: bold'>{`${word[2]}：` || '无'}</span>
                    <span>{word[3] || '无'}</span>
                  </div>
                )
              })
            ]
          }
        } else if (column.property === 'leaderViews') {
          // 领导意见
          return [
            wrap.map((item, index) => {
              // word 固定格式为
              // [0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:id
              const word = item.split('!&!')

              return (
                <div style={`text-align:${align};white-space:normal; `} key={index}>
                  <span>{`${word[0]} ` || '无'}</span>
                  <span style='font-weight: bold'>{`${word[1]}：` || '无'}</span>
                  <span>{word[2] || '无'}</span>
                </div>
              )
            })
          ]
        } else if (column.property === 'designHistory') {
          if (isExport) {
            return wrap
              .map(item => {
                // word 固定格式为
                // [0]:岗位  [1]:日期  [2]:需求点  [3]:设计变更内容
                const word = item.split('!&!')

                // 使用div（块级元素）即可实现span分行
                // white-space 可以让 div 内超出宽度的文字换行，但表格自带的 tooltip 会丢失
                return `[${word[0] || '无'}] ${word[1] || '无'} 需求点: ${word[2] || '无'}; 变更内容: ${word[3] ||
                  '无'}`
              })
              .join('\n')
          } else {
            // 设计变更
            return [
              wrap.map((item, index) => {
                // word 固定格式为
                // [0]:岗位  [1]:日期  [2]:需求点  [3]:设计变更内容
                const word = item.split('!&!')

                // 使用div（块级元素）即可实现span分行
                // white-space 可以让 div 内超出宽度的文字换行，但表格自带的 tooltip 会丢失
                return (
                  <div style={`text-align:${align};white-space:normal; `} key={index}>
                    <span style='color:#555'>{`[${word[0] || '无'}] `}</span>
                    <span>{`${word[1]} ` || '无'}</span>
                    <span style='font-weight:bold;'>需求点: </span>
                    <span>{`${word[2]}` || '无'}; </span>
                    <span style='font-weight:bold;'>变更内容: </span>
                    <span>{`${word[3]}` || '无'}</span>
                  </div>
                )
              })
            ]
          }
        }
      }

      // 当前值无需分割句内字段，如签字日期
      return [
        wrap.map((item, index) => {
          // 使用div（块级元素）即可实现分行
          // white-space:normal 实现文字超出div宽度后换行
          return (
            <div style={`text-align:${align};white-space:normal;`} key={index}>
              {' '}
              {item}
            </div>
          )
        })
      ]
    },

    // -------------------------- 表格操作 --------------------------
    // 右键打开菜单
    contextMenuClickEvent({ row, column, menu }) {
      if (!this.Authority.edit) {
        this.$message.warning('您没有相关操作权限')
        return false
      }

      if (this.isLockCantOperate) {
        this.$message.warning('单据已被锁定，暂时无法操作')
        return false
      }

      this.areas = this.$refs.xTable.getCellAreas()
      // 复现问题: 首先随便选中一行 => 进行筛选 => 直接右键写说明
      // 这时候areas.rows会变成一个空数组, 正常肯定会有右键的那个数组
      // vxe自身的问题, 以下方法可以暂时解决
      // 实测监听过滤条件变化时清理cellAreas无法解决
      // 这边只能判断, 如果有选中范围但是rows没数据的就手动插入右键的那一行
      if (this.areas.length === 1 && this.areas[0].rows.length === 0) {
        this.areas[0].rows = [row]
      }

      // 打开批量说明新增弹窗
      if (menu.code === 'comment') {
        this.openMoreInstructionEditModal()
        return
      }

      // 打开领导意见弹窗
      if (menu.code === 'leaderViews') {
        this.openOpinionEdit()
        return
      }
      // 打开工作量互评弹窗（目前只能操作当前点击的单元格，不能批量行操作）
      if (menu.code === 'workTime') {
        this.openWorkTimeModal(row, column)
        return
      }

      // 签名：目前只能签当前点击的单元格，不能批量签
      if (menu.code === 'sign') {
        // 签名
        this.sign(row, column)
        return
      }

      // 取消签名：目前只能操作当前点击的单元格，不能批量操作
      if (menu.code === 'unSign') {
        // 签名
        this.unSign(row, column)
        return
      }

      // 不处理 | 撤销处理：目前只能操作当前点击的单元格，不能批量操作
      if (menu.code === 'caseStatus') {
        this.handle(menu, row)
        return
      }

      // 除不处理、恢复处理外的其他状态：可以批量操作
      if (menu.code === 'caseStatusSet') {
        this.saveStrField(menu.name, column.property)
        return
      }

      // 批量选中checkbox
      if (menu.code === 'selectCheckbox') {
        this.areas.forEach(area => {
          for (let row of area.rows) {
            const CHECKED = true
            this.$refs.xTable.setCheckboxRow(row, CHECKED)
          }
        })
        return
      }

      // 文档类型：作为字符串型进行保存 [文档编号 | 模块 | 页面]
      if (menu.code === 'docNumber' || menu.code === 'groupName' || menu.code === 'vuePath') {
        this.inputType = menu.code
        this.openBatchInputModal()
        return
      }

      // 设置本行设计变更
      if (menu.code === 'setDesign') {
        this.setRowDesign(row)
      }

      // 查看本行设计变更
      if (menu.code === 'searchDesign') {
        this.openDesignHistoryWindow({ vuePath: row.vuePath, productionType: this.curProductType })
      }

      // 设置详细设计
      if (menu.code === 'setDetailDesign') {
        this.setDetailDesign(row)
      }

      if (menu.code === 'viewDetailDesignByMenu') {
        this.viewDetailDesign({
          vuePath: row.vuePath,
          designType: column.property === 'frontDesignCol' ? '前端' : '后端'
        })
      }

      if (menu.code === 'viewDetailDesignByQuestion') {
        this.viewDetailDesign(
          {
            ykCaseID: row.id,
            // vuePath: row.vuePath,
            designType: column.property === 'frontDesignCol' ? '前端' : '后端'
          },
          [
            {
              label: row.num,
              value: row.id
            }
          ]
        )
      }

      // 作为字符串型直接进行保存的列名 [紧急 | 类型 | 系统版本]
      const strSaveList = ['isPriority', 'type', 'productionVersion']
      if (strSaveList.includes(column.property)) {
        this.saveStrField(menu.name, column.property)
        return
      }

      // 更改错误等级
      if (menu.code === 'errorLevel') {
        if (menu.name === '清空') {
          this.saveStrField('', column.property)
        } else {
          this.saveStrField(menu.name, column.property)
        }
      }
    },
    // 错误等级 - 提出人权限， 若问题没有闭环提出人可以直接修改错误等级
    getErrorLevelBySuper() {
      let proposerAuthority = true

      const areas = this.$refs.xTable.getCellAreas()
      for (const area of areas) {
        for (let row of area.rows) {
          if (
            this.ykDateFormat('yyyy-MM-dd', row['confirmDate']) ||
            row['createtor'] !== this.curUserName ||
            row['type'] !== '错误'
          ) {
            proposerAuthority = false
          }
        }
      }
      return proposerAuthority
    },
    // 快捷键
    visibleMethod({ row, options, column }) {
      options.forEach(allRightMenuList => {
        allRightMenuList.forEach(menuItem => {
          if (!column || !this.Authority.edit) {
            // 隐藏右键菜单：1.点击非表格的地方 2.无编辑权限
            menuItem.visible = false
          } else {
            switch (menuItem.code) {
              // [签名] 和 [撤销签名]，根据权限判断
              // 0.超级权限都可以签名
              // 1.判断是否有对应的本人权限
              // 2.若有权限则显示右键菜单，反之隐藏
              case 'unSign':
              case 'sign': {
                const isShowMenu = this.isOwn(row, column)
                menuItem.visible = isShowMenu
                break
              }
              // 工作量由前后端互评, 且只能评当月的工作量(特殊权限不限制，可以评所有工作量)
              case 'workTime': {
                const isShowMenu = this.isCanWorkTime(row, column)
                menuItem.visible = isShowMenu
                break
              }
              // 领导意见
              case 'leaderViews': {
                const isCanShow = () => {
                  // 可见条件：1.有特殊权限  2.列名对应得上
                  return !!this.specialAuthority.leader && menuItem.code === column.property
                }
                const isShowMenu = isCanShow()
                menuItem.visible = isShowMenu
                break
              }
              // 问题状态
              case 'caseStatus': {
                const isCanShow = () => {
                  // 可见条件：1.有超级权限（或当前行的提出人为本人） 2.列名对应得上
                  return (
                    (!!this.specialAuthority.super || row['createtor'] === this.curUserName) &&
                    menuItem.code === column.property
                  )
                }
                const isShowMenu = isCanShow()
                menuItem.visible = isShowMenu
                break
              }
              // 问题状态（除不处理、恢复处理外的选项）
              case 'caseStatusSet': {
                const isCanShow = () => {
                  // 可见条件：1.有超级权限 2.列名为：问题状态
                  return !!this.specialAuthority.super && column.property === 'caseStatus'
                }
                const isShowMenu = isCanShow()
                menuItem.visible = isShowMenu
                break
              }
              // 系统版本
              case 'productionVersion': {
                const isCanShow = () => {
                  // 可见条件：1.有超级权限或单独的权限 2.列名对应得上 3.menuItem.comment(即产品类型)能对应上当前选中的产品类型
                  return (
                    (!!this.specialAuthority.super || !!this.specialAuthority.editVersion) &&
                    column.property === 'productionVersion' &&
                    menuItem.comment === this.curProductType
                  )
                }
                const isShowMenu = isCanShow()
                menuItem.visible = isShowMenu
                break
              }
              // 说明内容
              case 'comment': {
                const isCanShow = () => {
                  // 可见条件：1.有编辑权限 2.列名对应得上
                  return this.Authority.edit && column.property === menuItem.code
                }
                const isShowMenu = isCanShow()
                menuItem.visible = isShowMenu
                break
              }
              case 'selectCheckbox': {
                menuItem.visible = column.type === 'checkbox'
                break
              }
              case 'setDesign':
                // 有编辑权限且在设计变更列操作时
                menuItem.visible = column.property === 'designHistory' && this.Authority.edit
                break
              case 'setDetailDesign':
                // 有编辑权限且在设计变更列操作时
                menuItem.visible =
                  (column.property === 'frontDesignCol' || column.property === 'backDesignCol') &&
                  (row['frontDesigners'].split('、').includes(this.curUserName) ||
                    row['backDesigners'].split('、').includes(this.curUserName)) &&
                  this.Authority.edit
                break
              case 'viewDetailDesignByMenu':
              case 'viewDetailDesignByQuestion':
                // 有编辑权限且在设计变更列操作时
                menuItem.visible = column.property === 'frontDesignCol' || column.property === 'backDesignCol'
                break
              case 'searchDesign':
                // 有编辑权限且在设计变更列操作时
                menuItem.visible = column.property === 'designHistory'
                break
              // 错误等级
              case 'errorLevel':
                // 可见条件: 1. 有特殊权限 或 未闭环且为提出人 2. 列名对应得上
                menuItem.visible =
                  column.property === menuItem.code &&
                  (this.getErrorLevelBySuper() || !!this.specialAuthority.errorLevel)
                break
              // 除 [签名] 和 [撤销签名] 外，其他列的右键菜单显示条件：1.为当前列 2.有超级权限(super)
              default: {
                const isCanShow = () => {
                  return !!this.specialAuthority.super && menuItem.code === column.property
                }
                const isShowMenu = isCanShow()
                menuItem.visible = isShowMenu
                break
              }
            }
          }
        })
      })
      return true
    },
    // 点击事件
    cellContextMenuEvent({ column }) {
      if (!this.Authority.edit) {
        return false
      }

      if (this.isLockCantOperate) {
        this.$message.warning('单据已被锁定，暂时无法操作')
        return false
      }

      this.areas = this.$refs.xTable.getCellAreas()

      const colName = column.property
      // 支持打开人员选择框的列名
      const personList = [
        'createtor',
        'research',
        'frontEngineer',
        'backEngineer',
        'techTester',
        'businessTester',
        'frontAssessor',
        'backAssessor'
      ]
      // 多选人员框
      const personListMore = ['frontDesigners', 'backDesigners']
      // 支持打开日期选择框的列名
      const dateList = ['createDate', 'dueDate']
      // 支持打开天数选择框的列名
      const dayList = ['techTestDay', 'businessTestDay', 'confirmDay']
      // 可编辑的列
      const normalCanEdit = [
        'frontEngineer',
        'backEngineer',
        'frontAssessor',
        'backAssessor',
        'frontDesigners',
        'backDesigners'
      ]
      // 拥有超级权限才可编辑的列
      const superCanEdit = [
        'createtor',
        'research',
        'techTester',
        'businessTester',
        'createDate',
        'dueDate',
        'techTestDay',
        'businessTestDay',
        'confirmDay'
      ]

      // 有编辑权限 || 有超级权限
      const hasEdit = normalCanEdit.includes(colName) && this.Authority.edit
      const hasSuper = superCanEdit.includes(colName) && this.specialAuthority.super

      if (hasEdit || hasSuper) {
        // 打开人员选择框
        if (personList.includes(colName)) {
          // 校验是否能打开人员选择框
          if (!this.isCanOpenPersonSelect(colName)) {
            return
          }

          // 提出人、前端研发、后端研发、技术测试、业务测试、前端评价人、后端评价人需要按岗位来过滤
          this.personSqlTitle = `post:${this.perSqlTitleMap[colName]}`

          // 当前点击的列名
          this.curSelectCol = colName
          this.openEmployeeSelect()
          return
        }

        // 打开多选人员选择框
        if (personListMore.includes(colName)) {
          // 校验是否能打开多选人员选择框
          if (!this.isCanOpenPersonSelect(colName)) {
            return
          }

          // 提出人、前端研发、后端研发、技术测试、业务测试、前端评价人、后端评价人需要按岗位来过滤
          this.personSqlTitle = `post:${this.perSqlTitleMap[colName]}`

          // 当前点击的列名
          this.curSelectCol = colName
          this.openEmployeeSelectMore()
          return
        }

        // 打开日期选择框
        if (dateList.includes(colName)) {
          // 校验是否能打开日期选择框
          if (!this.isCanOpenDateInput(colName)) {
            return
          }

          this.curSelectCol = colName
          // 若当前列为截止日期，则可以选未来的时间
          if (colName === 'dueDate') {
            this.$refs.DateInput.isLimitToday = false
          } else {
            this.$refs.DateInput.isLimitToday = true
          }
          this.$nextTick(() => {
            this.$refs.DateInput.formVisible = true
          })
          return
        }

        // 打开天数选择框
        if (dayList.includes(colName)) {
          // 校验是否能打开天数选择框
          if (!this.isCanOpenDaySelect(colName)) {
            return
          }

          this.curSelectCol = colName
          this.openDaySelectModal()
          return
        }
      }
    },
    // （目前只能操作一条，故暂时弃用）是否能调用 [不处理 | 恢复处理] 功能
    // 不能调用的情况：所拉选数据中同时包含 '不处理' 和 '待处理' 不同问题状态的数据
    isCanShowHandle() {
      // 计数器：分别为不处理和其他状态
      let countUnHandle = 0
      let countHandle = 0
      let res = true

      this.areas.forEach(area => {
        for (let row of area.rows) {
          if (row['caseStatus'] === '不处理') {
            countUnHandle++
          } else {
            countHandle++
          }

          // 当两种数据同时存在时，则报错并提示
          if (countUnHandle >= 1 && countHandle >= 1) {
            res = false
            break
          }
        }
      })
      if (!res) {
        this.$message.warning('不可同时操作不同状态的问题')
      }
      return res
    },
    // 保存字符串型的列 [模块 | 页面 | 紧急 | 文档编号 | 类型 | 问题状态(除[不处理]和[恢复处理]外的状态用此接口调用)]
    async saveStrField(value, colName) {
      // 映射字典
      const map = {
        groupName: '模块',
        vuePath: '页面',
        isPriority: '紧急',
        docNumber: '文档编号',
        type: '类型',
        productionVersion: '系统版本',
        caseStatus: '问题状态',
        errorLevel: '错误等级'
      }
      // 当前传值类型
      const field = map[colName]
      const idList = [...this.getAreasIDList(colName)]

      const { data: res } = await this.$http.post('/Common/YKCase/strfeild', {
        iDs: idList,
        value: value,
        field: field
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getListPart(idList)
      // this.getList(false, false)
    },

    // 保存日期型的列 [提出日期 | 截止日期]
    async saveDateField(value, colName) {
      // 映射字典
      const map = {
        createDate: '提出日期',
        dueDate: '截止日期'
      }
      // 当前传值类型
      const field = map[colName]
      const idList = [...this.getAreasIDList()]

      const { data: res } = await this.$http.post('/Common/YKCase/datefeild', {
        iDs: idList,
        value: value,
        field: field
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getListPart(idList)
      // this.getList(false, false)
    },

    // 保存整数型的列 [技术测试天数 | 业务测试天数 | 确认人确认天数]
    async saveIntField(value, colName) {
      // 当前传值类型
      const field = this.PERSONTYPE[colName]
      const idList = [...this.getAreasIDList()]

      const { data: res } = await this.$http.post('/Common/YKCase/intfeild', {
        iDs: idList,
        value: value,
        field: field
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getListPart(idList)
      // this.getList(false, false)
    },

    //  不处理 | 恢复处理
    async handle(menu, row) {
      // 操作对应的不同接口
      const map = {
        不处理: 'nohandle',
        恢复处理: 'canclenohandle'
      }
      const url = map[menu.name]

      const { data: res } = await this.$http.put(`/Common/YKCase/${url}/${row.id}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getListPart([row.id])
      // this.getList(false, false)
    },
    // 签名设计
    async signDesign(num, rowID, curPersonPost, QUESTION_NUM_LIST = []) {
      const idList = [rowID]

      const { data: res } = await this.$http.post('/Common/YKCase/sign', {
        iDs: idList,
        // signerType: 前端研发 | 后端研发 | 技术测试 | 业务测试 | 提出人
        signerType: curPersonPost,
        workTime: num,
        QUESTION_NUM_LIST
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$refs.WorkTimeSelectForDesignRef.formVisible = false

      this.$message.success(res.data)
      this.getListPart(idList)
    },
    // 签名
    async sign(row, column) {
      // 获取当前人员岗位
      const curPersonPost = this.getPersonPost(column)
      if (curPersonPost === '前端设计' || curPersonPost === '后端设计') {
        this.$refs.WorkTimeSelectForDesignRef.rowID = row.id
        this.$refs.WorkTimeSelectForDesignRef.type = curPersonPost
        this.$refs.WorkTimeSelectForDesignRef.QUESTION_NUM_LIST = [row.num]

        this.$refs.WorkTimeSelectForDesignRef.formVisible = true
      } else {
        const idList = [row.id]
        // liufu 221110 写入系统日志时需要此参数
        // 问题编号调用接口的时候也给一下，主要用于系统日志记录
        const QUESTION_NUM_LIST = [row.num]

        const { data: res } = await this.$http.post('/Common/YKCase/sign', {
          iDs: idList,
          QUESTION_NUM_LIST,
          // signerType: 前端研发 | 后端研发 | 技术测试 | 业务测试 | 提出人
          signerType: curPersonPost
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.$message.success(res.data)
        this.getListPart(idList)
        // this.getList(false, false)
      }
    },

    // 取消签名
    async unSign(row, column) {
      // 获取当前人员岗位
      const curPersonPost = this.getPersonPost(column)
      const idList = [row.id]
      // liufu 221110 写入系统日志时需要此参数
      // 问题编号调用接口的时候也给一下，主要用于系统日志记录
      const QUESTION_NUM_LIST = [row.num]

      const { data: res } = await this.$http.post('/Common/YKCase/cancelsign', {
        iDs: idList,
        QUESTION_NUM_LIST,
        // signerType: 前端研发 | 后端研发 | 技术测试 | 业务测试 | 提出人
        signerType: curPersonPost
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getListPart(idList)
      // this.getList(false, false)
    },

    // 根据本人所在本行数据，获取本人岗位，并转化为接口预设的岗位值
    getPersonPost(column) {
      // [解决日期] 和 [最后确认日期] 列都可以右键签名
      const postMap = {
        // [前端详设确认日期]: [前端研发],
        frontDesignConfirmationTime: '前端设计',
        backDesignConfirmationTime: '后端设计',
        // [前端解决日期]：[前端研发]
        frontResolvedDateStr: '前端研发',
        frontResolvedDate: '前端研发',
        // [后端解决日期]：[后端研发]
        backResolvedDateStr: '后端研发',
        backResolvedDate: '后端研发',
        // [技术测试确认日期]：[技术测试]
        techTestDateStr: '技术测试',
        techTestDate: '技术测试',
        // [业务测试确认日期]：[业务测试]
        businessTestDateStr: '业务测试',
        businessTestDate: '业务测试',
        // [提出人确认日期]： [提出人]
        confirmDate: '提出人'
      }
      const colName = column.property
      const res = postMap[colName]

      return res
    },

    /**
     * 判断是否能打开日期输入框（日期相同的才可以打开）
     * @param {String} colName 需要判断的列名
     */
    isCanOpenDateInput(colName) {
      let isCanOpen = true
      // 存首行的日期，用于判断其他行的日期是否与之相同
      let dateMap = new Map()

      for (let i = 0; i < this.areas[0].rows.length; i++) {
        const row = this.areas[0].rows[i]
        // 1.记录第一行的日期
        if (i === 0) {
          dateMap.set(this.ykDateFormat('yyyy-MM-dd', row[colName]), true)
          continue
        }

        // 2.与第一行的日期进行匹配
        if (!dateMap.has(this.ykDateFormat('yyyy-MM-dd', row[colName]))) {
          isCanOpen = false
          break
        }
      }

      if (!isCanOpen) {
        this.$message.warning('请选择日期一致的数据进行操作')
      }
      return isCanOpen
    },

    /**
     * 判断是否能打开天数输入框
     * 可打开条件：1.有超级权限
     */
    isCanOpenDaySelect() {
      let isCanOpen = this.specialAuthority.super

      if (!isCanOpen) {
        this.$message.warning('您暂无操作该列的权限')
      }
      return isCanOpen
    },

    /**
     * 判断是否能打开人员选择框
     * 可打开条件：
     * 1.[编辑权限]判断如下
     * 1.1 所拉选的该列解决人为本人
     * 1.2 所拉选的该列解决人为 '/'
     * 2.[超级权限]判断如下
     * 2.1 任一列都可打开
     * 3 问题已通过则不能打开
     * @param {String} colName 需要判断的列名
     */
    isCanOpenPersonSelect(colName) {
      let isCanOpen = true
      // 是否存在通过的问题（无特殊权限的，问题已通过后不可修改人员，[评价人]对应列除外）
      let isPass = !this.isUnPass(this.areas[0].rows)
      // 是否为 [评价人] 对应列
      let isAssessorCol = ['frontAssessor', 'backAssessor'].includes(colName)
      const isDesignersCol = ['frontDesigners', 'backDesigners'].includes(colName)

      if (this.specialAuthority.super) {
        return isCanOpen
      }

      if (!isAssessorCol && isPass) {
        this.$message.warning('问题已通过，不可修改人员')
        return false
      }

      for (let i = 0; i < this.areas[0].rows.length; i++) {
        const row = this.areas[0].rows[i]
        if (isDesignersCol) {
          if (row[colName] && row[colName] !== '/' && !row[colName].split('、').includes(this.curUserName)) {
            isCanOpen = false
            break
          }

          if (
            (colName === 'frontDesigners' &&
              this.ykDateFormat('yyyy-MM-dd HH:mm', row['frontDesignConfirmationTime'])) ||
            (colName === 'backDesigners' && this.ykDateFormat('yyyy-MM-dd HH:mm', row['backDesignConfirmationTime']))
          ) {
            this.$message.warning('选择中存在已确认的数据')
            return false
          }
        } else {
          // 若符合条件，则可以打开人员选择框
          if (row[colName] !== '/' && row[colName] !== this.curUserName) {
            isCanOpen = false
            break
          }
        }
      }

      if (!isCanOpen) {
        this.$message.warning('请选择解决人为空或为本人的数据')
      }
      return isCanOpen
    },

    /**
     * 判断权限：是否为本人
     * @param {Object} row 行数据
     * @param {String} column 当前点击的列数据
     */
    isOwn(row, column) {
      // 当前点击列名
      const colName = column.property
      if (colName === 'frontDesignConfirmationTime' || colName === 'backDesignConfirmationTime') {
        const authorityMap = {
          frontDesignConfirmationTime: 'frontDesigners',
          backDesignConfirmationTime: 'backDesigners'
        }

        const matchColName = authorityMap[colName]
        return row[matchColName].split('、').includes(this.curUserName)
      } else {
        // 对应的解决日期单元格，需对应的列为本人才可操作，字典如下：
        const authorityMap = {
          // [前端解决日期]：[前端研发]
          frontResolvedDateStr: 'frontEngineer',
          frontResolvedDate: 'frontEngineer',
          // [后端解决日期]：[后端研发]
          backResolvedDateStr: 'backEngineer',
          backResolvedDate: 'backEngineer',
          // [技术测试确认日期]：[技术测试]
          techTestDateStr: 'techTester',
          techTestDate: 'techTester',
          // [业务测试确认日期]：[业务测试]
          businessTestDateStr: 'businessTester',
          businessTestDate: 'businessTester',
          // [提出人确认日期]： [提出人]
          confirmDate: 'createtor'
        }
        // 当前列名对应的需检测的列
        const matchColName = authorityMap[colName]
        const res = row[matchColName] === this.curUserName

        return res
      }
    },
    /**
     * 判断权限：是否为对应的前后端
     * @param {Object} row 行数据
     * @param {String} column 当前点击的列数据
     */
    isCanWorkTime(row, column) {
      // 当前点击列名
      const colName = column.property

      if (colName !== 'frontWorkTime' && colName !== 'backWorkTime') {
        return false
      }

      if (row['type'] === '性能' || row['type'] === '错误') {
        this.$message.warning('性能优化及错误问题不允许评价工作量')
        return false
      }

      // 超级权限可以评任何人的工作量
      if (this.specialAuthority.super) {
        return true
      }
      // 2022-02-07 没有超级权限的，需要限制评价时间（提出日期31天内可改）
      if (this.checkIsOutTime(row['createDate'])) {
        this.$message.warning('无法评估超出提出日期一个月的工作量')
        return false
      }
      // 对应的单元格需符合对应规则，字典如下：
      const authorityMap = {
        // [前端工作量]： [后端评价人] 前后端工作量互评
        frontWorkTime: 'backAssessor',
        // [后端工作量]： [前端评价人] 前后端工作量互评
        backWorkTime: 'frontAssessor'
      }
      // 当前列名对应的需检测的列
      const matchColName = authorityMap[colName]
      const res = row[matchColName] === this.curUserName

      return res
    },
    // 判断当前行是否已保存
    isRowSave(row) {
      // id存在且大于0即说明当前行已保存
      return row.id && row.id > 0
    },

    // 返回时间
    sureBackDate(value) {
      // 作为日期型进行保存的列名 [提出日期 | 截止日期]
      this.saveDateField(value, this.curSelectCol)
    },

    // 打开工作量评估弹窗
    openWorkTimeModal(row, column) {
      const rowID = row.id
      const type = this.PERSONTYPE[column.property]
      this.$refs.WorkTimeSelect.formVisible = true
      this.setWorkTimeData(rowID, type)
    },
    setWorkTimeData(rowID, type) {
      this.$refs.WorkTimeSelect.rowID = rowID
      this.$refs.WorkTimeSelect.type = type
    },

    // 打开天数评估弹窗
    openDaySelectModal() {
      this.$refs.DaySelect.formVisible = true
    },
    sureBackDay(value) {
      // 作为整数型进行保存的列名 [技术测试天数 | 业务测试天数 | 确认人确认天数]
      this.saveIntField(value, this.curSelectCol)
    },

    // 打开批量输入框
    openBatchInputModal() {
      this.$refs.BatchInput.formVisible = true
    },
    // 批量输入框返回值
    sureBackBatch(value) {
      this.saveStrField(value, this.inputType)
    },

    // 切换产品类型
    changeSelect(type) {
      // 注意！每次切换必须缓存产品类型值，才能在保存和activated触发时取到当前选择的类型
      this.optionsValue = type
      this.$store.commit('set_productType', this.optionsValue)
      // 重新加载列，可以清除列头筛选（第二个参数根据isSearchAll来显示，如果是[查看本人]，则无需跳转）
      this.getList(true, this.isSearchAll)
      this.InitColumns()
    },

    // 双击查看明细数据
    // params: { row, rowIndex, column, columnIndex }, event
    handleDbClick({ row, column }) {
      // 清除表格内的 tooltip
      this.$refs.xTable.closeTooltip()

      if (column.property === 'designHistory') {
        // 双击设计变更列时，打开设计变更
        this.openDesignHistoryWindow({ vuePath: row.vuePath, productionType: this.curProductType })
      } else if (column.property === 'frontDesignCol' || column.property === 'backDesignCol') {
        this.viewDetailDesign(
          {
            ykCaseID: row.id,
            // vuePath: row.vuePath,
            designType: column.property === 'frontDesignCol' ? '前端' : '后端'
          },
          [
            {
              label: row.num,
              value: row.id
            }
          ]
        )
      } else {
        this.openInstructionEditModal()
        this.setModalData(row)
      }
    },
    // 打开问题编辑弹窗(单条说明)
    openInstructionEditModal() {
      this.$refs.InstructionEdit.isShow = !this.$refs.InstructionEdit.isShow
    },
    // 设置弹窗数据(单条说明)
    setModalData(rowData) {
      const data = JSON.parse(JSON.stringify(rowData))
      this.$refs.InstructionEdit.form = data
      // 当前页的所有行id（用于上一条、下一条）
      this.$refs.InstructionEdit.curPageRowData = JSON.parse(JSON.stringify(this.tableData))
      // 当前行id
      this.curSelectID = rowData.id
    },
    // 打开问题编辑弹窗(批量说明)
    openMoreInstructionEditModal() {
      // 当前行是否已保存
      let isCurRowSave = true
      // 拉选行中是否存在自己不可操作的数据
      // let isCurRowCantDo = false
      // 当前所处岗位的缓存值，若拉选数据中本人处于多种类型岗位（比如一行作为前端，一行作为后端），则不允许新增说明
      let curSelectPostCache = []
      // 提出人、前端研发、后端研发、技术测试、业务测试对应的列
      const personMap = ['createtor', 'frontEngineer', 'backEngineer', 'techTester', 'businessTester']
      // 当前批量选中的行id
      let curSelectMoreID = []
      // 批量选中的问题编号
      let curSelectMoreNum = []

      for (let row of this.areas[0].rows) {
        // 当前人匹配对应行数据的岗位
        const POST_LIST = personMap.filter(colName => {
          return row[colName] === this.curUserName
        })

        // list 为空，说明该行的所有人员中不包含本人【暂时弃用，其他人也可对别人的问题写说明】
        // if (POST_LIST.length === 0 && !this.specialAuthority.super) {
        //   isCurRowCantDo = true
        //   break
        // }
        // 将当前人匹配的岗位作为缓存，key为拼接的岗位值（可能为多岗）
        const POST_STR = POST_LIST.join(',')
        curSelectPostCache.push(POST_STR)

        if (!this.isRowSave(row)) {
          isCurRowSave = false
          break
        }

        // 将拉选的id数组存进缓存，供批量新增说明用
        curSelectMoreID.push(row.id)
        // 将拉选的问题编号缓存, 主要用于写入系统日志
        curSelectMoreNum.push(row.num)
      }
      if (!isCurRowSave) {
        this.$message.warning('拉选数据中存在未保存数据，请先保存再操作')
        return
      }

      // 报错条件：数据存在非本人数据 && 无超级权限
      // if (isCurRowCantDo) {
      //   this.$message.warning('拉选数据存在非本人可操作数据')
      //   return
      // }

      // 用set去重复，当set中大于1条数据，说明拉选数据中本人存在多种岗位
      const POST_SET = new Set(curSelectPostCache)
      // 报错条件：数据存在多种岗位 && 无超级权限
      if (POST_SET.size > 1 && !this.specialAuthority.super) {
        this.$message.warning('拉选数据中本人处于多种岗位，请操作相同岗位的数据')
        return
      }
      // 用扩展运算符触发响应式监听，不然子组件中监听不到
      // this.curSelectMoreID = [...this.curSelectMoreID]
      this.$nextTick(() => {
        // 岗位缓存值赋值
        this.$refs.MoreInstructionEdit.curPost = curSelectPostCache
        // 当前选中行的id
        this.$refs.MoreInstructionEdit.idList = curSelectMoreID
        // 但钱选中行的Num
        this.$refs.MoreInstructionEdit.numList = curSelectMoreNum
        // 打开弹窗
        this.$refs.MoreInstructionEdit.isShow = !this.$refs.MoreInstructionEdit.isShow
      })
    },
    // 设置单元格颜色
    // 单元格颜色优先于整行颜色，则需先单独匹配单元格，再匹配整行
    tableCellStyle({ row, column }) {
      // [是否紧急] 为是：单元格显示红色
      if (
        (column.property === 'isPriority' && row.isPriority === '是') ||
        (column.property === 'type' && row.type === '错误')
      ) {
        return {
          backgroundColor: this.cellBgColorMap['red'],
          color: this.cellTextColorMap['red']
        }
      }

      // [说明/领导意见] 不为空：单元格显示浅棕色
      if (
        // 注意！判断 null 应放在判断空字符串前面，因为null没有 trim 方法
        (column.property === 'comment' && row.comment != null && row.comment.trim() !== '') ||
        (column.property === 'leaderViews' && row.leaderViews != null && row.leaderViews.trim() !== '')
      ) {
        return {
          backgroundColor: this.cellBgColorMap['orange'],
          color: this.cellTextColorMap['orange']
        }
      }

      // [问题状态] 超期未解决：整行粉红色
      // [问题状态] 超期已解决：整行浅绿色
      // [问题状态] 已解决：整行浅黄色
      // [问题状态] 不处理：整行浅紫色
      const statusMap = {
        超期未解决: 'pink',
        超期已解决: 'green',
        已解决: 'yellow',
        不处理: 'purple'
      }
      const rowValue = row['caseStatus']
      let bgColor = statusMap[rowValue]

      // 技术测试天数判断
      if (['techTestDateStr', 'techTestDate', 'techTestDay'].includes(column.property)) {
        if (row['techTestDay'] > 2) {
          bgColor = 'red'
        }
      }

      // 业务测试天数判断
      if (['businessTestDateStr', 'businessTestDate', 'businessTestDay'].includes(column.property)) {
        if (row['businessTestDay'] > 2) {
          bgColor = 'red'
        }
      }

      return {
        backgroundColor: this.cellBgColorMap[bgColor],
        color: this.cellTextColorMap[bgColor]
      }
    },

    // -------------------------- 按钮工具栏 --------------------------
    // 切换查询面板可见性
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 保存(该界面只有新增，没有update的情况；针对每列的更新操作，都会调用独立的接口)
    async save() {
      // 超级权限
      if (!this.specialAuthority.super) {
        this.$message.warning('您没有相关操作权限')
        return false
      }

      let insertRecords = this.$refs.xTable.getInsertRecords()
      // 保存时需要将如 menuArgs="铁塔" 赋值
      insertRecords.forEach(v => {
        v.menuArgs = this.curProductType
      })
      let tableData = this.removeArrayNull(insertRecords)

      const { data: res } = await this.$http.post('/Common/YKCase/insertlist', tableData)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getList(true, true)

      // this.$nextTick(() => {
      // })
    },
    // 点击查询，切换查看模式（全查 | 过滤本人）
    search() {
      this.isSearchAll = !this.isSearchAll
      this.$message.success(this.isSearchAll ? '查看全部' : '查看本人')
      this.$nextTick(() => {
        this.getList(true, this.isSearchAll)
      })
    },
    // 点击刷新按钮，刷新数据和锁定状态
    refresh(isResetPager = false, isToUncomplete = false) {
      // 刷新当前页面数据
      this.getList(isResetPager, isToUncomplete)
      // 刷新锁定状态
      this.getIsLock()
    },
    // 导入
    import() {
      if (!this.specialAuthority.super) {
        this.$message.warning('您没有相关操作权限')
        return false
      }

      this.$refs.Import.isShow = !this.$refs.Import.isShow
    },
    // 返回导入值 | 明细主信息
    async sureImportBack(selectRecords) {
      // ↓ 点击确认后才进行的关联
      // selectRecords.forEach(item => {
      //   // 当前产品类型
      //   item.menuArgs = this.curProductType
      // })
      // const { data: res } = await this.$http.post('/Common/YKCase/excelcreate', selectRecords)
      // if (!res.isSuccess) {
      //   this.$message.error(res.errorMessage)
      //   return false
      // }
      // // 总共导入数据行数
      // const oldLength = selectRecords.length
      // // 关联到数据行数
      // const newLength = res.data.length
      // // 未关联到的数据行数
      // const diffLength = oldLength - newLength

      // if (res.data.length > 0) {
      //   this.$refs.xTable.insertAt(res.data, -1)
      // }

      // if (diffLength > 0) {
      //   this.$message.warning(`导入成功，但有 ${diffLength} 条数据未关联到基础设置`)
      // } else {
      //   this.$message.success('全部导入成功')
      // }
      // ↑ 点击确认后才进行的关联

      if (selectRecords.length > 0) {
        this.$refs.xTable.insertAt(selectRecords, -1)
      }
    },
    // 返回导入值 | 明细主信息
    // sureImportBack (selectRecords) {
    //   if (selectRecords.length > 0) {
    //     this.$refs.xTable.insertAt(selectRecords, -1)
    //   }
    // },
    // 导出
    export() {
      this.$refs.xTable.exportData({
        filename: this.ykDateFormat('yyyy-MM-dd', new Date()) + this.curProductType + '问题汇总和解决情况表',
        type: 'xlsx',
        columnFilterMethod({ column }) {
          let unExportList = [
            'isIssued',
            'isIssued',
            'fileURL',
            'frontResolvedDate',
            'backResolvedDate',
            'techTestDate',
            'businessTestDate',
            'frontAssessor',
            'backAssessor',
            'designHistory'
          ]
          return !['checkbox', 'seq'].includes(column.type) && !unExportList.includes(column.property)
        }
      })
    },
    // 锁定(超级权限才可操作)
    async lock() {
      const { data: res } = await this.$http.put('/Common/YKCase/lock')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.isLock = true
      // 需要重新初始化锁定和解锁按钮
      this.$nextTick(() => {
        this.initButton()
      })
    },
    // 解锁(超级权限才可操作)
    async unlock() {
      const { data: res } = await this.$http.put('/Common/YKCase/unlock')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.isLock = false
      // 需要重新初始化锁定和解锁按钮
      this.$nextTick(() => {
        this.initButton()
      })
    },

    // -------------------------- 其他 --------------------------
    // 打开领导意见弹窗
    openOpinionEdit() {
      this.$refs.OpinionEdit.isShow = !this.$refs.OpinionEdit.isShow
      this.setOpinionModalData()
    },
    // 赋值领导意见弹窗数据
    setOpinionModalData() {
      this.$refs.OpinionEdit.form.iDs = [...this.getAreasIDList()]
    },

    // 保存所拉选的行ID
    getAreasIDList(colName = '') {
      let res = []
      // 将行id保存
      this.areas.forEach(area => {
        for (let row of area.rows) {
          // 如果为修改错误等级, 则只提取类型为错误的行
          if (colName === 'errorLevel' && row.type !== '错误') {
            continue
          }
          res.push(row.id)
        }
      })
      return res
    },

    // 打开员工选择框
    openEmployeeSelect() {
      this.$refs.EmployeeSelect.formVisible = true
    },
    openEmployeeSelectMore() {
      this.$refs.EmployeeMoreSelect.formVisible = true
    },
    // 员工选择框返回值
    sureBackPerson(selectRecords) {
      // selectRecords: {
      //   id
      //   num // 用户名
      //   name // 姓名
      //   post // 岗位
      // }
      this.changePerson(this.curSelectCol, selectRecords.name)
    },
    // 员工多选
    sureBackPersonMore(selectRecords) {
      const selectRecordsName = selectRecords.map(item => item.name).join('、')
      this.changePerson(this.curSelectCol, selectRecordsName)
    },
    // 修改人员
    async changePerson(colName, newPerson) {
      // 获取选中行的id
      const idList = [...this.getAreasIDList()]

      const { data: res } = await this.$http.post('/Common/YKCase/handler', {
        iDs: idList,
        // 新人员
        handlerName: newPerson,
        // 岗位类型
        handlerType: this.PERSONTYPE[colName]
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getListPart(idList)
      // this.getList(false, false)
    },

    // 打开附件上传弹窗
    // 2022-09-08 新的附件方式：根据行id来获取附件
    openAttachmentDisplay(row) {
      this.$refs.AttachmentDrawer.attachmentDrawerCanUnLoad = false
      this.$refs.AttachmentDrawer.rowId = row.id

      this.$nextTick(() => {
        this.attachmentDisplay = true
      })
    },
    // 打开上传文件框
    handleOpenFile(row, type = 'moreRow') {
      if (type === 'moreRow') {
        this.curSelectAttchmentIDList = []
        const checkedRecords = this.getCheckedRecords()
        if (checkedRecords.length === 0) {
          this.$message.warning('请勾选要操作的数据')
          return
        }
        checkedRecords.forEach(row => {
          this.curSelectAttchmentIDList.push(row.id)
        })
      } else {
        this.curSelectAttchmentIDList = [row.id]
      }
      this.$refs.uploadExcel.click()
    },
    async uploadFile(event) {
      // 多条上传
      if (this.curSelectAttchmentIDList.length > 0) {
        this.$refs.AttachmentDrawer.attachRowIdList = this.curSelectAttchmentIDList
      } else {
        // 单条上传
        this.$refs.AttachmentDrawer.attachRowIdList = [this.curSelectID]
      }
      this.$refs.AttachmentDrawer.uploadFile(event)
    },
    // 上传附件窗口打开
    attachmentUpload() {
      if (this.specialAuthority.super || this.specialAuthority.attachment) {
        this.$refs.AttachmentUpload.formVisible = true
      }
    },
    // 获取当前行的年月（评估工作量限制只能当前月的问题，以[截止日期]为计算基准）
    getCurRowDate(row) {
      const date = new Date(row['dueDate'])
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      return { year, month }
    },
    // 检查当前日期是否当年当月
    checkIsCurYearMonth(year, month) {
      const curYear = new Date().getFullYear()
      const curMonth = new Date().getMonth() + 1

      if (curYear === year && curMonth === month) return true
      return false
    },
    // 检查当前日期是否超出范围（提出日期 <=31 为不超期）
    checkIsOutTime(createDate) {
      const curDateTime = new Date(this.ykDateFormat('yyyy-MM-dd', new Date())).getTime()
      const createDateTime = new Date(this.ykDateFormat('yyyy-MM-dd', createDate)).getTime()
      // 86400:一天秒数  1000:精确到毫秒
      const day = 86400 * 1000
      const diffDay = (curDateTime - createDateTime) / day

      if (diffDay > 31) {
        // 超时
        return true
      }
      // 未超时
      return false
    },
    // #region 下发流程相关
    // 生成下发流程
    handleIssuedFlow() {
      const checkedRecords = this.getCheckedRecords()
      // 判断是否存在不可下发数据
      const isIssueDataValid = this.isIssueDataValid(checkedRecords)
      if (!isIssueDataValid) {
        // TODO 若存在，则弹窗显示并询问是否自动去除不合法数据的勾选
        return
      }
      // 配置下发流程弹窗数据
      this.setIssueModalData(checkedRecords)
      this.$nextTick(() => {
        // 打开弹窗
        this.openIssueFlowEditModal()
      })
    },

    // 获取已勾选数据
    getCheckedRecords() {
      // 是否获取全表勾选的数据
      const isFull = false
      return this.$refs.xTable.getCheckboxRecords(isFull)
    },

    // 判断已勾选的问题是否可生成下发流程
    isIssueDataValid(records) {
      if (records.length === 0) {
        this.$message.warning('请选择要下发的问题编号')
        return false
      }
      const isUnPass = this.isUnPass(records)
      if (isUnPass) {
        this.$message.warning('通过的问题才能进行下发')
        return false
      }

      return true
    },

    // 所选问题是否为未通过
    isUnPass(records) {
      return records.some(row => {
        // [提出人确认日期] 为空时，说明问题未通过
        return row.confirmDate.includes('1900')
      })
    },

    // 配置下发流程弹窗数据
    setIssueModalData(checkRecords) {
      let idList = []
      checkRecords.forEach(row => {
        idList.push(row.id)
      })
      this.$refs.issueFlowEdit.idList = idList
      // 产品类型
      this.$refs.issueFlowEdit.menuArgs = this.curProductType
    },

    // 打开下发流程弹窗弹窗（填写实际更新版本和备注）
    openIssueFlowEditModal() {
      this.$refs.issueFlowEdit.isShow = !this.$refs.issueFlowEdit.isShow
    },
    // #endregion
    clearFilter() {
      this.$message.info('清空筛选中...')
      // 加延迟可以让提示在点击时弹出，而不是在清除后弹出
      setTimeout(() => {
        this.$refs.xTable.clearFilter()
        this.refreshStatisticsData()
      }, 100)
    },
    // 刷新统计数据
    refreshStatisticsData() {
      if (!this.statisticsVisible) return
      // 使用 setTimeout 确保 vxe-table 内部已经完成渲染和筛选等更新
      setTimeout(() => {
        if (this.$refs.xTable) {
          const currentData = this.$refs.xTable.getTableData().visibleData || this.tableData
          this.statisticsData = this.$utils.clone(currentData, true)
        }
      }, 300)
    },
    // 切换数据统计面板显示
    toggleStatistics() {
      this.statisticsVisible = !this.statisticsVisible
      if (this.statisticsVisible) {
        this.refreshStatisticsData()
      }
    },
    // 筛选开发未解决问题
    searchUncomplete() {
      const gangWei = this.curUserGangWei
      const isFront = gangWei.includes('前端研发')
      const isBack = gangWei.includes('后端研发')

      if (isFront) {
        this.$refs.xTable.setFilter(this.$refs.xTable.getColumnByField('frontEngineer'), [
          {
            data: {
              vals: [this.curUserName],
              sVal: '',
              fMenu: '',
              f1Type: '',
              f1Val: '',
              fMode: 'and',
              f2Type: '',
              f2Val: '',
              f1: '',
              f2: ''
            },
            checked: true,
            _checked: true
          }
        ])
        this.$refs.xTable.setFilter(this.$refs.xTable.getColumnByField('frontResolvedDate'), [
          {
            data: {
              vals: ['1900-01-01 00:00:00'],
              sVal: '',
              fMenu: '',
              f1Type: '',
              f1Val: '',
              fMode: 'and',
              f2Type: '',
              f2Val: '',
              f1: '',
              f2: ''
            },
            checked: true,
            _checked: true
          }
        ])
      } else if (isBack) {
        this.$refs.xTable.setFilter(this.$refs.xTable.getColumnByField('backEngineer'), [
          {
            data: {
              vals: [this.curUserName],
              sVal: '',
              fMenu: '',
              f1Type: '',
              f1Val: '',
              fMode: 'and',
              f2Type: '',
              f2Val: '',
              f1: '',
              f2: ''
            },
            checked: true,
            _checked: true
          }
        ])
        this.$refs.xTable.setFilter(this.$refs.xTable.getColumnByField('backResolvedDate'), [
          {
            data: {
              vals: ['1900-01-01 00:00:00'],
              sVal: '',
              fMenu: '',
              f1Type: '',
              f1Val: '',
              fMode: 'and',
              f2Type: '',
              f2Val: '',
              f1: '',
              f2: ''
            },
            checked: true,
            _checked: true
          }
        ])
      }

      setTimeout(() => {
        this.$refs.xTable.updateData()
        this.refreshStatisticsData()
      }, 100)
    },

    // 清空复选框
    clearCheckBox() {
      this.$refs.xTable.clearCheckboxRow()
    },

    // 切换分页
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.getList()
    },

    // 打开新增问题弹窗
    addNewProblem() {
      this.$refs.AddNewProblemModal.isShow = !this.$refs.AddNewProblemModal.isShow
    },

    // 筛选变化
    filterChange() {
      this.refreshStatisticsData()
    },

    // 合计
    footerMethod({ columns, data }) {
      const sums = []
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push('合计')
        } else {
          let sumCell = null
          switch (column.property) {
            case 'frontWorkTime':
            case 'backWorkTime':
              sumCell = this.$utils.sum(data, column.property)
              break
          }
          sums.push(sumCell)
        }
      })
      // 返回一个二维数组的表尾合计
      return [sums]
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      // 统计面板展开时需减去面板高度
      let statisticsHeight = this.statisticsVisible ? this.statisticsPanelHeight : 0
      return this.tableHeightComputed(tableMargin + this.topBottomMargin + statisticsHeight, isSearchForm, isToolBar)
    },
    // 当前选中的产品类型
    curProductType() {
      return this.$store.state.productType
    },
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    },
    // 当前用户的岗位
    curUserGangWei() {
      // 可能存在多岗，用逗号分隔
      const res = this.$store.state.userInfo.gangWei.split(',')
      return res
    },
    // 是否全量查询问题的过滤条件
    searchSqlTitle() {
      if (this.isSearchAll) {
        return ''
      } else {
        return 'default'
      }
    },
    // 是否因为锁定而无法操作，判断条件：
    // 1.无超级权限 2.当前状态被锁定
    isLockCantOperate() {
      if (!this.specialAuthority.super && this.isLock) {
        // 无法操作当前页面
        return true
      }
      // 可以操作当前页面
      return false
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 100px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

// 查找面板过渡渐变
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

// 行高度，需要比 row-config 的 height 多20px，可以让内容与单元格之间有内边距
/deep/ .vxe-body--row {
  height: 80px !important;
}
/deep/ .el-link.el-link--primary.is-disabled {
  color: #999999;
}
</style>
